// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7170a540","638":"9c3409bc","791":"0b184ba9","902":"c77407c4","935":"a22c43ec"}[chunkId] + ".chunk.js";
};